<template>
    <div v-if="!loading" id="atmo-top" class="purchases_create atmo-page atmo-hash-jump-point">
        <b-container class="purchase-offer-header-block" fluid>
            <b-container>
                <b-row>
                    <b-col>
                        <p class="fs-40 fw-600 white-color mt-3 mb-3">Подача предложения на закупку 44ФЗ с неопределённым объёмом <br />№ {{ purchase.reg_number }}</p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <p class="white-color fs-14">Форма подачи предложения</p>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>
        <b-container class="my-2" fluid>
            <b-container>
                <b-card class="my-3" no-body>
                    <b-card-header class="p-1" header-tag="header" role="tab">
                        <h2 class="grey-color font-weight-bold my-2 ml-3 cursor-pointer">Информация об извещении</h2>
                    </b-card-header>
                    <b-card-body>
                        <text-header>Информация о заказчике</text-header>
                        <text-row-link compact :label-cols-lg="4" :label-cols-sm="4" label="Наименование" v-model="purchase.customer.full_name" :router-link="{ name: 'OrganizationShow', params: { id: purchase.customer.id } }" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Рейтинг" :value="$formatPrice(purchase.customer.customer_rating)" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ИНН" v-model="purchase.customer.inn" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="КПП" v-model="purchase.customer.kpp" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="ОГРН" v-model="purchase.customer.ogrn" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Юридический адрес" v-model="purchase.customer.legal_address" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительная контактная информация" v-model="purchase.purchase_terms.contact_info" v-if="purchase.purchase_terms.contact_info" />

                        <text-header>Условия закупки</text-header>
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Предмет закупки" :value="purchase.purchase_terms.deliverable_group.name" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Объект закупки" :value="purchase.purchase_terms.purchase_object" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Тип закупки" :value="purchase.purchase_terms.order_type.name" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Продолжительность закупочной сессии" :value="purchase.purchase_terms.duration_type.name" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Размер аванса, %" :value="purchase.purchase_terms.advance_percentage" />
                        <text-row-price compact :label-cols-lg="4" :label-cols-sm="4" label="Цена контракта" :value="purchase.purchase_terms.contract_price" />
                        <text-row-datetime compact :label-cols-lg="4" :label-cols-sm="4" label="Дата и время размещения закупки" :value="purchase.published_at" />
                        <text-row-datetime compact :label-cols-lg="4" :label-cols-sm="4" label="Дата и время окончания приема предложений" :value="purchase.purchase_end" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата заключения договора" :value="purchase.purchase_terms.planned_contract_conclusion_date" />
                        <text-row-date compact :label-cols-lg="4" :label-cols-sm="4" label="Планируемая дата исполнения договора" :value="purchase.purchase_terms.planned_contract_execution_date" />
                        <text-row-single-document compact :label-cols-lg="4" :label-cols-sm="4" label="Проект ГК" :value="purchase.purchase_terms.contract_draft_attachment" />
                        <text-row-single-document v-if="purchase.purchase_terms.commercial_proposal_form_attachment" compact :label-cols-lg="4" :label-cols-sm="4" label="Образец коммерческого предложения для заполнения" :value="purchase.purchase_terms.commercial_proposal_form_attachment" />
                        <text-row-documents compact :label-cols-lg="4" :label-cols-sm="4" label="Дополнительные документы" v-model="purchase.additional_documents" v-if="purchase.additional_documents.length > 0" />
                        <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="Информация о возможности и случаях одностороннего расторжения сделки в соответствии с действующим законодательством Российской Федерации" :value="purchase.purchase_terms.unilateral_contract_termination_info ?? 'Нет'" text-wrap />

                        <template v-if="purchase.delivery_terms.addresses.length > 0 || purchase.delivery_terms.schedule">
                            <text-header>Условия поставки</text-header>
                            <b-form-group v-if="purchase.delivery_terms.addresses.length > 0" :label-cols-sm="4" :label-cols-lg="4" label="Адреса для доставки/самовывоза:" label-class="py-0 fs-14 grey-color fw-700 d-flex align-items-baseline" class="mb-0">
                                <ul>
                                    <li v-for="(address, index) in purchase.delivery_terms.addresses" :key="index" class="py-0 fs-14 grey-color my-auto col-form-label">{{ address }}</li>
                                </ul>
                            </b-form-group>
                            <text-row compact :label-cols-lg="4" :label-cols-sm="4" label="График поставки товаров (выполнения работ, оказания услуг)" :value="purchase.delivery_terms.schedule" />
                        </template>
                    </b-card-body>
                </b-card>

                <text-header>Подтверждение требований к поставщикам</text-header>
                <text-row v-if="purchase.supplier_requirements.only_smp" compact :label-cols-sm="11" :label-cols-lg="11" value-class="text-right mr-2" label="Участником закупки могут быть только субъекты малого предпринимательства (СМП)" :value="purchase.supplier_requirements.only_smp ? 'Да' : 'Нет'" />

                <template v-if="purchase.supplier_requirements.supplier_reqs_a">
                    <form-row-edit-checkbox
                        :label-cols-sm="11"
                        :label-cols-lg="11"
                        form-class="text-right"
                        v-model="form.supplier_requirements_confirmed.supplier_reqs_a"
                        :v="$v.form.supplier_requirements_confirmed.supplier_reqs_a"
                        label="Подтверждаю, что соответствую требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                        compact />
                    <div style="word-break: break-all" class="form-row">
                        <div class="col">
                            <p class="fs-14 grey-color my-1"><strong>Подтверждаю, что соответствую следующим требованиям</strong> - {{ purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_text }}</p>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col">
                            <p class="fs-14 grey-color mt-2 mb-1"><strong>Подтверждаю, что соответствую указанным требованиям, приложив следующие документы:</strong></p>
                        </div>
                    </div>
                    <form-row-single-line-document-upload
                        v-for="(item, index) in purchase.supplier_requirements.supplier_reqs_a_details.supplier_reqs_a_documents"
                        :key="`supplier_required_document_${index}`"
                        :title="item.name"
                        v-model="form.supplier_requirements_confirmed.supplier_required_documents[index].storedDocument"
                        :v="$v.form.supplier_requirements_confirmed.supplier_required_documents.$each[index].storedDocument"
                        :label-cols-lg="4"
                        compact />
                </template>
                <form-row-edit-checkbox
                    v-if="purchase.supplier_requirements.supplier_reqs_b"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    form-class="text-right"
                    v-model="form.supplier_requirements_confirmed.supplier_reqs_b"
                    :v="$v.form.supplier_requirements_confirmed.supplier_reqs_b"
                    label="Подтверждаю, что соответствую требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    compact />
                <form-row-edit-checkbox
                    v-if="purchase.supplier_requirements.supplier_reqs_c"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    form-class="text-right"
                    v-model="form.supplier_requirements_confirmed.supplier_reqs_c"
                    :v="$v.form.supplier_requirements_confirmed.supplier_reqs_c"
                    label="Подтверждаю, что соответствую требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ"
                    compact />
                <form-row-edit-checkbox
                    v-if="purchase.supplier_requirements.supplier_reqs_sonko"
                    :label-cols-sm="11"
                    :label-cols-lg="11"
                    form-class="text-right"
                    v-model="form.supplier_requirements_confirmed.supplier_reqs_sonko"
                    :v="$v.form.supplier_requirements_confirmed.supplier_reqs_sonko"
                    label="Подтверждаю, организация является социально ориентированной некоммерческой организацией (СОНКО)"
                    compact />
                <template v-if="purchase.supplier_requirements.has_additional_requirements">
                    <div class="form-row">
                        <div class="col">
                            <p class="fs-14 grey-color my-2 mb-1">
                                <strong>Подтверждаю соответствие дополнительным требованиям, приложив следующие документы:</strong>
                            </p>
                        </div>
                    </div>
                    <form-row-single-line-document-upload
                        v-for="(item, index) in purchase.supplier_requirements.additional_requirements"
                        :key="`additional_requirement_${index}`"
                        v-model="form.supplier_requirements_confirmed.additional_requirements[index].attachment"
                        :label-cols-lg="4"
                        :title="`${index + 1}. ${item.description} (причина: ${item.reason})`"
                        :v="$v.form.supplier_requirements_confirmed.additional_requirements.$each[index].attachment"
                        compact />
                </template>

                <text-header>Информация об организации</text-header>
                <form-row-edit-text v-model="form.contact_name" :v="$v.form.contact_name" label="Контактное лицо поставщика" />
                <form-row-single-line-document-upload v-model="form.organization_card" :label-cols-lg="3" :label-cols-sm="3" :v="$v.form.organization_card" title="Карточка предприятия" />
                <form-row-edit-checkbox v-model="form.without_vat" label="Организация освобождена от уплаты НДС" />

                <fl44-unknown-volume-form-row-proposal-specification-table v-model="form.deliverables" :vat-dictionary="dictionaries.vat" :v="$v.form.deliverables" :purchase-deliverables="purchase.deliverables" :without-vat="form.without_vat" :spec-errors="specErrors" :spec-error-message="specErrorMessage" />

                <AccordionItem :visible="$route.hash === '#explanation-requests'" title="Запросы разъяснений по закупке" class="atmo-hash-jump-point mt-3" id="explanation-requests">
                    <ExplanationRequestList v-if="!!purchase.id" :purchase-item="purchase" purchase-type="fl44UnknownVolume" />
                </AccordionItem>

                <text-header margin-class="mb-3 mt-2">Документы</text-header>
                <form-row-single-line-document-upload :label-cols-lg="4" v-model="form.commercial_proposal" :v="$v.form.commercial_proposal" title="Коммерческое предложение" />
                <form-row-single-line-multiple-documents-upload :label-cols-lg="4" title="Дополнительные документы" v-model="form.attachments" :v="$v.form.attachments" />

                <p v-if="purchase.fee_amount && !form.existing_proposal" class="font-weight-bold grey-color">При подаче предложения на лицевом счету Вашей организации, в соответствии с регламентом, будет заблокирована сумма {{ $formatPrice(purchase.fee_amount) }} руб.</p>

                <b-row class="my-5">
                    <b-col>
                        <b-button class="mr-2" variant="custom-outline-secondary" @click="cancelOffer">Отменить</b-button>
                        <b-button :disabled="$v.$invalid || !$store.getters.getCanSign" class="mx-2" variant="custom-green" @click="validateForm">Подать предложение</b-button>
                        <template v-if="!$store.getters.getCanSign">
                            <span v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Для действия требуется загрузить/заменить МЧД на странице: <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link></span>
                            <span v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подача и изменение предложения возможны только при авторизации при помощи ЭЦП</span>
                        </template>
                        <template v-else-if="$v.$invalid && !$v.form.accountingAvailable">
                            <span class="text-danger px-3 pt-0 fs-14 w-50 my-auto">Необходимо для блокировки <strong>{{ $formatPrice(purchase.fee_amount) }}</strong> руб. Для подачи предложения не хватает <strong>{{ $formatPrice(Math.abs(roundToTwoDecimals(accounting.sum_available + accounting.already_blocked_sum - commission))) }}</strong> руб.</span>
                            <router-link :to="{ name: 'CabinetAccounting' }" class="system_link-style fs-14">Пополнить лицевой счет</router-link>
                        </template>
                    </b-col>
                </b-row>
            </b-container>
        </b-container>

        <b-modal ref="sign-form-modal" v-model="showSignModal" centered hide-header-close no-close-on-backdrop no-close-on-esc size="lg" title="Подписать предложение">
            <div class="d-block text-left">
                <b-tabs content-class="mt-3">
                    <b-tab active>
                        <template #title>
                            <span class="system_link-style fs-16">Форма</span>
                        </template>
                        <text-row v-model="purchase.reg_number" label="Закупочная сессия" />
                        <h4 class="font-weight-bold">Спецификация</h4>
                        <b-form-group>
                            <ul>
                                <li v-for="(item, index) in form.deliverables" :key="index" class="fs-14 grey-color my-auto col-form-label py-1">{{ index + 1 + '.' }} {{ getPurchaseDeliverable(item.id).ktru_item.name }} - {{ getPurchaseDeliverable(item.id).ktru_item.okei_local_symbol }}: Цена за ед. {{ item.price }} руб.{{ form.without_vat ? '' : `, НДС${item.vat}%`}}</li>
                            </ul>
                        </b-form-group>
                    </b-tab>
                    <b-tab>
                        <template #title>
                            <span class="system_link-style fs-16">XML</span>
                        </template>
                        <b-form-textarea v-if="!isSignedXml" v-model="formXml" class="text-monospace fs-12" disabled no-auto-shrink no-resize rows="20" wrap="off"></b-form-textarea>
                        <b-form-textarea v-else v-model="signedFormXml" class="text-monospace fs-12" disabled no-auto-shrink no-resize rows="20" wrap="off"></b-form-textarea>
                    </b-tab>
                </b-tabs>
            </div>
            <div slot="modal-footer" class="w-100 px-3">
                <text-row :value="certificate?.subjectName" label="Сертификат" />
                <b-button :disabled="isDataSending" class="mr-2 text-uppercase" variant="custom-outline-secondary" @click="cancelSignModal">Отмена</b-button>
                <b-overlay v-if="!isSignedXml" :show="isSigningXml" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="signForm">Подписать</b-button>
                </b-overlay>
                <b-overlay v-else :show="isDataSending" class="d-inline-block" opacity="0.6" rounded spinner-small spinner-variant="primary">
                    <b-button :disabled="!certificate" class="text-uppercase" variant="custom-green" @click="sendData">Отправить</b-button>
                </b-overlay>
            </div>
        </b-modal>
    </div>
</template>

<script>
import TextHeader from '@/components/common/form-rows/text-header';
import TextRowLink from '@/components/common/form-rows/text-row-link';
import TextRow from '@/components/common/form-rows/text-row';
import TextRowPrice from '@/components/common/form-rows/text-row-price';
import TextRowDocuments from '@/components/common/form-rows/text-row-documents';
import { maxValue, minValue, required, requiredIf, sameAs } from 'vuelidate/lib/validators';
import TextRowSingleDocument from '@/components/common/form-rows/text-row-single-document.vue';
import { createMultipleSignatures, getCertificate } from 'crypto-pro';
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';
import Fl44UnknownVolumeFormRowProposalSpecificationTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-form-row-proposal-specification-table.vue';
import ExplanationRequestList from '@/components/purchases/ExplanationRequests/ExplanationRequestList.vue';
import AccordionItem from '@/components/common/accordion-item.vue';
import FormRowSingleLineMultipleDocumentsUpload from '@/components/common/form-rows/form-row-single-line-multiple-documents-upload.vue';

export default {
    name: 'fl44-unknown-volume-purchase-proposal-create',
    metaInfo() {
        return {
            title: 'Подача предложения на закупку 44ФЗ с неопределённым объёмом'
        };
    },
    components: {
        FormRowSingleLineMultipleDocumentsUpload,
        AccordionItem, ExplanationRequestList,
        Fl44UnknownVolumeFormRowProposalSpecificationTable,
        TextRowSingleDocument,
        TextRowDocuments,
        TextRowPrice,
        TextRow,
        TextRowLink,
        TextHeader
    },
    data() {
        return {
            isSigningXml: false,
            isDataSending: false,
            formXml: '',
            isSignedXml: false,
            loading: true,
            showSignModal: false,
            showAttentionModal: false,
            visible: [],
            signedFormXml: null,
            signedAttachments: [],
            purchase: null,
            accounting: null,
            dictionaries: [],
            form: {
                existing_proposal: false,
                existing_proposal_id: null,
                organization_card: null,
                commercial_proposal: null,
                without_vat: false,
                contact_name: '',
                deliverables: [],
                attachments: [],
                supplier_requirements_confirmed: {
                    supplier_reqs_sonko: false,
                    supplier_reqs_a: false,
                    supplier_required_documents: [],
                    supplier_reqs_b: false,
                    supplier_reqs_c: false,
                    additional_requirements: []
                },
                delivery_time_days: 1,
                delivery_cost: null
            },
            proposalTotalCost: 0,
            isPurchaseLoading: true,
            isGettingXML: false,
            isCertificateChecking: false,
            selectCertificate: null,
            certificate: null
        };
    },
    validations() {
        return {
            form: {
                contact_name: { required },
                organization_card: { required },
                without_vat: {},
                commercial_proposal: {},
                supplier_requirements_confirmed: {
                    supplier_reqs_sonko: {
                        sameAs: sameAs(() => this.purchase.supplier_requirements.supplier_reqs_sonko)
                    },
                    supplier_reqs_a: {
                        sameAs: sameAs(() => this.purchase.supplier_requirements.supplier_reqs_a)
                    },
                    supplier_required_documents: {
                        required: requiredIf(() => this.purchase.supplier_requirements.supplier_reqs_a),
                        $each: {
                            storedDocument: { required }
                        }
                    },
                    supplier_reqs_b: {
                        sameAs: sameAs(() => this.purchase.supplier_requirements.supplier_reqs_b)
                    },
                    supplier_reqs_c: {
                        sameAs: sameAs(() => this.purchase.supplier_requirements.supplier_reqs_c)
                    },
                    additional_requirements: {
                        $each: {
                            attachment: {
                                required
                            }
                        }
                    }
                },
                deliverables: {
                    required,
                    $each: {
                        required,
                        price: {
                            required,
                            minValue: minValue(0.01),
                            maxValue: maxValue(this.purchase.purchase_terms.contract_price)
                        },
                        vat: {
                            required: requiredIf(() => !this.form.without_vat)
                        }
                    }
                },
                attachments: {},
                accountingAvailable: () => roundToTwoDecimals(this.accounting.sum_available + this.accounting.already_blocked_sum ?? 0) - this.commission >= 0
            }
        };
    },
    async mounted() {
        await this.fillData();
        this.loading = false;
    },
    methods: {
        roundToTwoDecimals,
        async validateForm() {
            this.certificate = await getCertificate(this.$store.getters.getCurrentThumbprint);
            if (!this.certificate) {
                return;
            }
            this.showSignForm();
        },
        showSignForm() {
            this.$api.products.fl44UnknownVolume.purchases.getProposalXML(this.$route.params.id, this.form).then((resp) => {
                this.formXml = resp.xml;
                this.showSignModal = true;
            });
        },
        async signForm() {
            this.isSigningXml = true;
            const dataToSign = [
                {
                    method: 'xml',
                    value: this.formXml
                }
            ];
            if (this.form.commercial_proposal) {
                dataToSign.push({
                    method: 'detached',
                    value: this.form.commercial_proposal.hash,
                    id: this.form.commercial_proposal.id
                });
            }
            if (this.form.attachments.length > 0) {
                this.form.attachments.forEach((item) => {
                    dataToSign.push({
                        method: 'detached',
                        value: item.hash,
                        id: item.id
                    });
                });
            }
            const attachmentsCount = dataToSign.filter((item) => item.method === 'detached').length;
            try {
                const signedResult = await createMultipleSignatures(this.$store.getters.getCurrentThumbprint, dataToSign, true)
                this.signedFormXml = signedResult.find((item) => item.method === 'xml').result;
                this.signedAttachments.splice(0);
                if (attachmentsCount > 0) {
                    dataToSign.filter((item) => item.method === 'detached').forEach((item) => {
                        const result = signedResult.find((resultItem) => resultItem.method === 'detached' && resultItem.value === item.value);
                        this.signedAttachments.push({
                            id: item.id,
                            hash: item.value,
                            md5: result.result
                        });
                    })
                }
                this.isSignedXml = !!this.signedFormXml && this.signedAttachments.length === attachmentsCount && this.signedAttachments.every((item) => item.md5 !== null);
            } catch (e) {
                await this.$store.dispatch('showDangerToast', e.message);
            } finally {
                this.isSigningXml = false;
            }
        },
        cancelSignModal() {
            this.isSignedXml = false;
            this.showSignModal = false;
        },
        async fillData() {
            const purchaseData = await this.$api.products.fl44UnknownVolume.purchases.getProposalCreateData(this.$route.params.id);
            if (this.$store.state.organization.available_fl44_proposal_submission_status.id === 'blocked' && !purchaseData.proposal.existing_proposal) {
                this.pushToast({
                    text: this.$store.state.organization.available_fl44_proposal_submission_status.title + ' до ' + this.$store.state.organization.expiration_datetime_blocking_fl44_proposal_submission,
                    title: 'Ошибка',
                    variant: 'danger'
                });
                await this.$router.push({ name: 'Home' });
            }
            this.form = Object.assign({}, this.form, purchaseData.proposal);
            this.dictionaries = purchaseData.dictionaries;
            this.purchase = purchaseData.purchase;
            this.accounting = purchaseData.accounting;
        },
        getPurchaseDeliverable(id) {
            return this.purchase.deliverables.find((x) => x.id === id);
        },
        async sendData() {
            try {
                this.isDataSending = true;
                const responseData = await this.$api.products.fl44UnknownVolume.purchases.storeSignedProposal(this.$route.params.id, this.form, this.signedFormXml, this.certificate, this.signedAttachments);
                if (responseData) {
                    await this.onCancel();
                }
            } finally {
                this.isDataSending = false;
            }
        },
        async onCancel() {
            await this.$router.push({ name: 'CabinetFl44ProposalsList' });
        },
        cancelOffer() {
            this.onCancel();
        }
    },
    computed: {
        specErrors() {
            return !!this.specErrorMessage;
        },
        specErrorMessage() {
            if (!this.form.deliverables.every((e) => e.price > 0 && e.price <= this.purchase.purchase_terms.contract_price)) return `Одна или несколько позиций спецификации содержит недопустимое значение поля "Цена за ед., руб.". Значение должно быть больше 0 и не должно превышать цену контракта ${this.$formatPrice(this.purchase.purchase_terms.contract_price)} руб., указанную в извещении.`;
            if (!this.form.deliverables.every((e) => this.form.without_vat || e.vat !== null)) return 'У одной или более позиций в таблице спецификации не заполнено поле "НДС"';
            return '';
        },
        commission() {
            return Math.min(roundToTwoDecimals((this.purchase.purchase_terms.contract_price * this.accounting.commission_percentage) / 100), this.accounting.commission_max_sum);
        }
    }
};
</script>

<style scoped>
.purchase-offer-header-block {
    background-image: url('/images/purchases_head.svg');
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}

.head_register-list {
    color: var(--halfWhite-color);
}
</style>

<style scoped>
.main_layer {
    background-image: url('/images/purchases_head.svg');
    min-height: 250px;
}

.block_head-text {
    font-size: 32px;
    color: var(--grey-color);
    font-weight: 600;
    line-height: 48px;
    margin: 33px 0;
}

.table {
    border-collapse: collapse;
}

.table thead th {
    background: #e4e6e8;
    font-size: 14px;
    font-weight: 600;
    padding: 12px;
    color: var(--grey-color);
}

.table tbody td {
    font-size: 14px;
    /*font-weight: 600;*/
    padding: 12px;
    vertical-align: middle;
    border-bottom: 1px solid #dee2e6;
    color: var(--grey-color);
}
</style>

<style>
.new_offer .is-valid {
    border-color: rgb(206, 212, 218) !important;
    background: #fff !important;
}
</style>
